import { BatteryFormData } from "../components/formData/BatteryFormData";

export const parseSummaryToSuiteOption = (key: number, summaryItem: any) => {
  // STC, VEEC
  let stcVeecJson: any = getStcVeec(summaryItem);

  // Return
  let suiteJsonItem: any = {};
  if (!summaryItem) return suiteJsonItem;

  suiteJsonItem[`sanden_option_${key}`] = 0;
  suiteJsonItem[`recom_sd_option_${key}`] = 0;
  suiteJsonItem[`pmsd_${key}`] = null;
  suiteJsonItem[`sd_stc_total`] = stcVeecJson.stcTotal;
  suiteJsonItem[`sd_stc_${key}`] = stcVeecJson.stc;
  suiteJsonItem[`sd_cost_stc_${key}`] = stcVeecJson.costStc;
  suiteJsonItem[`sd_veec_total`] = stcVeecJson.veecTotal;
  suiteJsonItem[`sd_veec_${key}`] = stcVeecJson.veec;
  suiteJsonItem[`sd_cost_veec_${key}`] = stcVeecJson.costVeec;
  suiteJsonItem[`sd_install_plum_${key}`] = checkExistCategory(summaryItem, "plbInstallStd");
  suiteJsonItem[`sd_install_elec_${key}`] = checkExistCategory(summaryItem, "elecInstallStd");
  suiteJsonItem[`sd_subtotal_${key}`] = convertCurrencyToString(summaryItem.pdf.subTotal);
  suiteJsonItem[`sd_gst_${key}`] = convertCurrencyToString(summaryItem.pdf.gst);
  suiteJsonItem[`sd_full_price_${key}`] = convertCurrencyToString(summaryItem.subTotal);
  suiteJsonItem[`sd_rebate_${key}`] = convertCurrencyToString(summaryItem.rebate);
  suiteJsonItem[`sd_grandtotal_${key}`] = convertCurrencyToString(summaryItem.totalPrice);
  suiteJsonItem[`isSend`] = convertCurrencyToString(summaryItem.totalPrice) ? 1 : 0;
  suiteJsonItem[`completes`] = getJsonByCategory(key, summaryItem, "completes");
  suiteJsonItem[`accessories`] = getJsonByCategory(key, summaryItem, "accessories");
  suiteJsonItem[`extras`] = getJsonByCategory(key, summaryItem, "extras");
  suiteJsonItem[`rebates`] = getJsonByCategory(key, summaryItem, "rebates");

  return suiteJsonItem;
}

const getStcVeec = (summaryItem: any) => {
  let stcVeecJson: any = {};
  // stc
  let tmp = summaryItem.result && summaryItem.result.filter((item: any) => item.category === "stc")[0];
  if (tmp) {
    stcVeecJson.stcTotal = convertCurrencyToString(tmp.price);
    stcVeecJson.stc = tmp.qty;
    stcVeecJson.costStc = convertCurrencyToString(tmp.salePrice);
  }
  // veec
  tmp = summaryItem.result && summaryItem.result.filter((item: any) => item.category === "veec")[0];
  if (tmp) {
    stcVeecJson.veecTotal = convertCurrencyToString(tmp.price);
    stcVeecJson.veec = tmp.qty;
    stcVeecJson.costVeec = convertCurrencyToString(tmp.salePrice);
  }

  return stcVeecJson;
}

const checkExistCategory = (summaryItem: any, category: string) => {
  try {
    let tmpArr = summaryItem.result && summaryItem.result.filter((item: any) => item.category === category);
    if (tmpArr.length === 0)
      return "No";
    return "Yes";
  } catch (err) {
    return "No";
  }
}

const getJsonByCategory = (key: number, summaryItem: any, category: string) => {
  let result: any[] = [];
  let tmpArr = summaryItem.result && summaryItem.result.filter((item: any) => item.category === category);
  if (tmpArr.length > 0) {
    switch (category) {
      case "completes":
        tmpArr.forEach((item: any, line: number) => {
          result = {
            ...result,
            [line + 1]: {
              id: item.id,
              partNumber: item.partNumber,
              productName: item.name,
              short_name: "",
              [`sd_complete_type${line + 1}_${key}`]: item.partNumber,
              [`qty_sd_complete${line + 1}_${key}`]: item.qty,
            }
          }
        });
        break;
      case "accessories":
        tmpArr.forEach((item: any, line: number) => {
          result = {
            ...result,
            [line + 1]: {
              id: item.id,
              partNumber: item.partNumber,
              productName: item.name,
              short_name: "",
              [`sd_accessory_type${line + 1}_${key}`]: item.partNumber,
              [`qty_sd_accessory${line + 1}_${key}`]: item.qty,
            }
          }
        });
        break;
      case "extras":
        tmpArr.forEach((item: any, line: number) => {
          result = {
            ...result,
            [line + 1]: {
              id: item.id,
              partNumber: item.partNumber,
              productName: item.name,
              short_name: "",
              [`sd_extra_type${line + 1}_${key}`]: item.partNumber,
              [`qty_ext_sd_extra${line + 1}_${key}`]: item.qty.toString(),
              [`price_ext_sd_extra${line + 1}_${key}`]: item.cost.toString(),
              [`itemise_ext_sd_extra${line + 1}_${key}`]: item.itemise ? 1 : 0,
            }
          }
        });
        break;
      case "rebates":
        tmpArr.forEach((item: any, line: number) => {
          result = {
            ...result,
            [line + 1]: {
              id: item.id,
              partNumber: item.partNumber,
              productName: item.name,
              short_name: "",
              cost: item.cost,
              [`sd_ex_rebate_type${line + 1}_${key}`]: item.partNumber,
            }
          }
        });
        break;
      default: break;
    }
  }
  return result;
}

const convertCurrencyToString = (currency: string) => {
  if (!currency) return "";
  return typeof currency === 'string' ? currency.replaceAll('$','') : "";
}

const addEmptyNode = (key: number) => {
  return {
    [`sanden_option_${key}`]: 0,
    [`recom_sd_option_${key}`]: 0,
    [`pmsd_${key}`]: null,
    [`sd_stc_total`]: "",
    [`sd_stc_${key}`]: 0,
    [`sd_cost_stc_${key}`]: 0,
    [`sd_veec_total`]: "",
    [`sd_veec_${key}`]: 0,
    [`sd_cost_veec_${key}`]: 0,
    [`sd_install_plum_${key}`]: "no",
    [`sd_install_elec_${key}`]: "no",
    [`sd_subtotal_${key}`]: "",
    [`sd_gst_${key}`]: "",
    [`sd_full_price_${key}`]: "",
    [`sd_rebate_${key}`]: "",
    [`sd_grandtotal_${key}`]: "",
    [`isSend`]: 0,
    [`completes`]: [{
      id: "",
      partNumber: "",
      productName: "",
      short_name: "",
      [`sd_complete_type1_${key}`]: "",
      [`qty_sd_complete1_${key}`]: ""
    }],
    [`accessories`]: [{
      id: "",
      partNumber: "",
      productName: "",
      short_name: "",
      [`sd_accessory_type1_${key}`]: "",
      [`qty_sd_accessory1_${key}`]: ""
    }],
    [`extras`]: [{
      id: "",
      partNumber: "",
      productName: "",
      short_name: "",
      [`sd_extra_type1_${key}`]: "",
      [`qty_ext_sd_extra1_${key}`]: "",
      [`price_ext_sd_extra1_${key}`]: "",
      [`itemise_ext_sd_extra1_${key}`]: 0
    }],
    [`rebates`]: [{
      id: "",
      partNumber: "",
      productName: "",
      short_name: "",
      cost: "",
      [`sd_ex_rebate_type1_${key}`]: ""
    }],
  }
}

export const unescape = (s: string) => {
  return s.replace(/&amp;/g, "&")
          .replace(/&lt;/g, "<")
          .replace(/&gt;/g, ">")
          .replace(/&#39;/g, "'")
          .replace(/&quot;/g, '"');
}

export const addGeneralAttribute = (values: BatteryFormData) => {
  try {
    let suiteJson = values.summary ? JSON.parse(values.summary) : {};
    let extraLine = values.formchoice_extra ? JSON.parse(values.formchoice_extra) : {};
    let productChoice = values.product_choice ? JSON.parse(values.product_choice) : {};
    if (suiteJson) {
      // general attribute
      suiteJson.sanden_pricing = "";
      suiteJson.sd_complete_line = 1;
      suiteJson.sd_accessory_line = 1;
      suiteJson.sd_extra_line = extraLine ? Object.keys(extraLine).length : 0;
      suiteJson.sd_ex_rebate_line = 3;
      suiteJson.sd_pe_admin_percent = 19;
      suiteJson.state = values.state;
      suiteJson.postcode = values.zip;

      // 6th node
      suiteJson['6'] = addEmptyNode(6);

      // select option
      for (var i = 1; i < 7; i++) {
        if (productChoice.hasOwnProperty(i)) {
          suiteJson[i.toString()][`sanden_option_${i}`] = 1;
        } else {
          suiteJson[i.toString()][`sanden_option_${i}`] = 0;
        }
      }

      return suiteJson;
    }
  } catch (err) {
    console.log(err);
  }
}